import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'

import ArticleDate from '../ArticleDate/ArticleDate'
import ArticleSource from '../ArticleSource/ArticleSource'

import classes from './ArticleCard.module.css'

const ArticleCard = ({
  source,
  date,
  title,
  description,
  buttonText,
  slug,
  referer = '',
  externalLink = false
}) => {
  const navigate = useNavigate()
  const handleClick = () => {
    if (externalLink && referer) {
      window.open(referer, '_blank', 'noopener noreferrer')
    } else {
      navigate(`/blog/article/${slug}`)
    }
  }
  return (
    <div className={`${classes['article-card']}`}>
      <div className={`${classes['article-content']}`}>
        <div className={`${classes['article-meta']}`}>
          {source && <ArticleSource source={source} referer={referer} />}
          {date && <ArticleDate date={date} />}
        </div>

        {title && <h2 className={`${classes['article-title']}`}>{title}</h2>}
        {description && <p className={`${classes['article-description']}`}>{description}</p>}
      </div>

      <Button type="default" className={`${classes['read-button']}`} onClick={handleClick}>
        {buttonText}
      </Button>
    </div>
  )
}

export default ArticleCard
